import { Col, Row } from "antd";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { INITIAL_PAGE } from "../../../../utils/helpers/constants";
import FieldBuilder from "../../../form-components/field-builder";
import Form from "../../../form-components/from";
import ZoneContext from "../../../../context/wms/zone/context";
import useHierarchicalDropdown from "../../../../hooks/wms/use-hierarchical-dropdown";

const ZoneFilter: React.FC = () => {
  const { t } = useTranslation();
  const { actions, query } = useContext(ZoneContext);

  // Use hierarchical dropdown hook with progressive visibility
  const {
    stores,
    loadingStores,
    zoneTypes,
    loadingZoneTypes,
    selectedStoreId,
    selectedZoneTypeId,
    visibleLevels,
    setSelectedStoreId,
    setSelectedZoneTypeId,
  } = useHierarchicalDropdown({ debounceMs: 300 });

  return (
    <Form
      formId="zone-filter"
      onSubmit={(data) => {
        const filter: any = {
          page: INITIAL_PAGE,
          perPage: query?.perPage,
          keyword: query?.keyword,
          filters: [
            selectedStoreId
              ? { name: "storeId", value: selectedStoreId, operation: "eq" }
              : undefined,
            selectedZoneTypeId
              ? { name: "zoneTypeId", value: selectedZoneTypeId, operation: "eq" }
              : undefined,
            data?.isActive !== undefined && data?.isActive !== null
              ? { name: "isActive", value: data.isActive, operation: "eq" }
              : undefined,
          ].filter((f) => f),
        };
        actions.setQuery(filter);
      }}
    >
      <Row justify="start" gutter={[10, 0]}>
        <Col xs={24} sm={12} md={8}>
          <FieldBuilder
            name="storeId"
            label={t("select_store")}
            width="large"
            rules={{ required: false }}
            input={{
              type: "select",
              loading: loadingStores,
              allowSearch: true,
              options: stores.map((s) => ({
                label: s.label,
                value: s.id,
              })),
              onChange: setSelectedStoreId,
            }}
          />
        </Col>
        <Col xs={24} sm={12} md={8}>
          <FieldBuilder
            name="zoneTypeId"
            label={t("zone_type")}
            width="large"
            rules={{ required: false }}
            input={{
              type: "select",
              loading: loadingZoneTypes,
              allowSearch: true,
              options: zoneTypes.map((zt) => ({
                label: zt.label,
                value: zt.id,
              })),
              onChange: setSelectedZoneTypeId,
            }}
          />
        </Col>
        <Col xs={24} sm={12} md={8}>
          <FieldBuilder
            name="isActive"
            label={t("is_active")}
            width="large"
            rules={{ required: false }}
            input={{
              type: "select",
              options: [
                { label: t("active"), value: 1 },
                { label: t("inactive"), value: 0 },
              ],
            }}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default ZoneFilter;
